var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadAloudEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_555_1674)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_555_1674)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(9 9)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_555_1674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0263 19.7487C12.0576 19.7487 12.0888 19.7455 12.1201 19.7408L14.7482 19.2799C14.7794 19.2737 14.8091 19.2596 14.831 19.2362L21.4544 12.6127C21.4689 12.5983 21.4804 12.5811 21.4883 12.5622C21.4961 12.5433 21.5001 12.523 21.5001 12.5026C21.5001 12.4821 21.4961 12.4618 21.4883 12.4429C21.4804 12.424 21.4689 12.4069 21.4544 12.3924L18.8576 9.79397C18.8279 9.76428 18.7888 9.74866 18.7466 9.74866C18.7044 9.74866 18.6654 9.76428 18.6357 9.79397L12.0123 16.4174C11.9888 16.4408 11.9748 16.469 11.9685 16.5002L11.5076 19.1283C11.4924 19.2121 11.4978 19.2982 11.5234 19.3793C11.549 19.4605 11.594 19.5341 11.6544 19.594C11.7576 19.694 11.8873 19.7487 12.0263 19.7487ZM13.0794 17.0237L18.7466 11.358L19.8919 12.5033L14.2248 18.169L12.8357 18.4143L13.0794 17.0237ZM21.7498 21.0612H10.2498C9.97319 21.0612 9.74976 21.2846 9.74976 21.5612V22.1237C9.74976 22.1924 9.80601 22.2487 9.87476 22.2487H22.1248C22.1935 22.2487 22.2498 22.1924 22.2498 22.1237V21.5612C22.2498 21.2846 22.0263 21.0612 21.7498 21.0612Z",
    fill: "url(#paint0_linear_555_1674)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_555_1674",
    x: 0,
    y: 0,
    width: 32,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.043 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_555_1674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_555_1674",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_555_1674",
    x1: 16.0339,
    y1: 22.3166,
    x2: 16.0339,
    y2: 9.74866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2054E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C62FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_1674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_555_1674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadAloudEdit);
export default __webpack_public_path__ + "static/media/read-aloud-edit.6b67e2adcbab9dc825cb2daa29d77073.svg";
export { ForwardRef as ReactComponent };